import { render, staticRenderFns } from "./DeleteUserType.vue?vue&type=template&id=72347c1b&scoped=true"
import script from "./DeleteUserType.vue?vue&type=script&lang=js"
export * from "./DeleteUserType.vue?vue&type=script&lang=js"
import style0 from "./DeleteUserType.vue?vue&type=style&index=0&id=72347c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72347c1b",
  null
  
)

export default component.exports